import { render } from "./Toolbar.vue?vue&type=template&id=8557f9ca&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=8557f9ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8557f9ca"

export default script